<template>
  <BaseDataIterator :service="fetchData">
    <!-- props
      data, fetchList
    -->
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #default="dataTableProps">
          <SubscriptionTableRow
            :key="dataTableProps.item.id"
            :subscription="dataTableProps.item"
            @changed="dataIteratorProps.fetchList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { contactListSubscriptionsClient } from '@/api/clients';
import SubscriptionTableRow from './SubscriptionTableRow.vue';

export default {
  components: {
    SubscriptionTableRow,
  },
  props: {
    contactListId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fetchData(params = {}) {
      const queryParams = {
        ...params,
        include: 'contact',
      };

      return contactListSubscriptionsClient.list(this.contactListId, queryParams);
    },
  },
};
</script>
